import React from "react";
import { Link } from "react-router-dom";
import heroImage from "../assets/homepageHeroImage.png"; // Adjust the path as necessary

const Home = () => {
  return (
    <div>
      <div>
        <img
          src={heroImage}
          alt="Hero"
          style={{ width: "100%", height: "auto" }}
        />
      </div>
      <div
        style={{
          padding: "40px",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div className="d-flex flex-row justify-content-center">
          <div
            style={{
              margin: "40px auto",
              maxWidth: "400px",
              padding: "10px",
              borderRadius: "10px",
              backgroundColor: "#C74A02",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            }}
          >
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwiVu8Mrzywzr2dvRyi00Jn5s8x2iEgLz5ug&s"
              alt="ttd-logo"
              style={{ width: "100%", height: "200px", borderRadius: "10px" }}
            />
            <h2 style={{ color: "#FCE0AF" }}>Seva Tickets</h2>
            <Link to="/">
              <button
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#FCE0AF",
                  color: "#A02123",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Go to TTD Seva
              </button>
            </Link>
          </div>

          <div
            style={{
              margin: "40px auto",
              maxWidth: "400px",
              padding: "10px",
              borderRadius: "10px",
              backgroundColor: "#C74A02",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            }}
          >
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwiVu8Mrzywzr2dvRyi00Jn5s8x2iEgLz5ug&s"
              alt="ttd-logo"
              style={{ width: "100%", height: "200px", borderRadius: "10px" }}
            />
            <h2 style={{ color: "#FCE0AF" }}>TTD Seva Tickets</h2>
            <Link to="/">
              <button
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#FCE0AF",
                  color: "#A02123",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Go to TTD Seva
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
